import React, { useEffect, useState, useRef, forwardRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router";
import moment from "moment";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';

import routes from "../../libs/routes";
// import consts from '../../libs/consts';

import { logIn, logOut } from "../../redux/usersSlice";
import { open, close } from "../../redux/popupSlice";
import { loadingStart, loadingEnd } from "../../redux/loadingSlice";
import Popup01 from "../popup/Popup01";
import * as API from "../../libs/service";

import PaginationSetLicense from '../../components/PaginationSetLicense';

export default function PopupSubinfo(props) {
    const { 
        title,
        subTitle,
        text, 
        lefttext,
        width, 
        button, 
        buttonCancel, 
        func, 
        setFunc, 
        noneLoading, 
        top,
        cancelFunc,
        x_btn,
        cancelText,
        longButton,
        text1,
        text2,
        text3,
        text1_b,
        text2_b,
        text3_b,
        max_width,
        infoTitle,
        infolicense,
        SubinfoType, // 테스트용
        SubinfoPay, // 테스트용
        SubinfoTest, // 테스트용
        license, // License
        payList,
        subscribelist,
        payinfolists
    } = props;

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { mbData } = useSelector((s) => s.usersReducer);
    const lang = useSelector(state => state.langReducer.lang);

    const dueDate = ((new Date(license.licenseGroup.expiredAt) - new Date(license.licenseGroup.createdAt)) / (1000 * 60 * 60 * 24)).toFixed(0);

    const [diffdateCount, setdiffdateCount] = useState(0);
    console.log(payList);
    useEffect(() => {

        if(license.licenseGroup.groupId === ''){
            const startDate = moment();
            const endDate = moment(license.licenseGroup?.expiredAt);
            const daysDiff = endDate.diff(startDate, 'days');
            setdiffdateCount(daysDiff);
        } else {
            const startDate = moment();
            const endDate = moment(subscribelist[0]?.endDate);
            const daysDiff = endDate.diff(startDate, 'days');
            setdiffdateCount(daysDiff);
        }
        if (!buttonCancel && !button && top) {
            const popup = document.querySelector(".popup.show");
            /* console.log(popup); */
            if (popup) popup.classList.add("popup_top");
            const timeout = setTimeout(() => {
                dispatch(close());
            }, 1000);
            popup.addEventListener("click", () => {
                dispatch(close());
                clearTimeout(timeout);
            });
        }
    }, [subscribelist]);

    const setFunction = () => {
        if(setFunc) setFunc();
        dispatch(close());
    };

    console.log("license : ", license);

    const isTrial = license.licenseGroup.groupId === '';
    //const isTrial = true;

    return (
        <>
            <div 
                className={"popup_default01"} 
                style={{ 
                    maxWidth: max_width ? max_width : '400px', 
                    width: '100%', 
                    marginLeft: 10, 
                    marginRight: 10,
                }}
                >
                {x_btn &&
                    <div 
                        className="popup_x_btn_box"
                    >
                        <img src={require("../../assets/images/exit-icon.svg").default} 
                            className="popup_x_btn" 
                            onClick={() => {
                                dispatch(close());
                            }}
                            style={{ cursor: isBrowser ? 'pointer' : 'auto' }}
                        />
                        <div style={{ height: 16 }} />
                    </div>
                }
                <div 
                    className="popup_content_box subinfo"
                >
                    {text1 && 
                        <div
                            className="popup_text_box"
                        >
                            <p>{text1}</p>
                        </div>
                    }

                    {text1_b && // 마진 위아래 있음
                        <div
                            className="popup_text_box mar"
                        >
                            <b>{text1_b}</b>
                        </div>
                    }

                    {text2 && 
                        <div
                            className="popup_text_box"
                        >
                            <p>{text2}</p>
                        </div>
                    }

                    {text2_b && 
                        <div
                            className="popup_text_box"
                        >
                            <b>{text2_b}</b>
                        </div>
                    }

                    {text3 && 
                        <div
                            className="popup_text_box"
                        >
                            <p>{text3}</p>
                        </div>
                    }

                    {text3_b && 
                        <div
                            className="popup_text_box"
                        >
                            <b>{text3_b}</b>
                        </div>
                    }

                    {title && 
                        <div
                            className="popup_title_box"
                        >
                            <p>{title}</p>
                        </div>
                    }

                    {subTitle && 
                        <div
                            className="popup_sub_title_box"
                        >
                            <p>{subTitle}</p>
                        </div>
                    }
                    {text &&
                        <div
                            className="popup_text_box"
                            style={!buttonCancel && !button ? { padding: "0" } : {}}
                        >
                            <p>{text}</p>
                        </div>
                    }

                    {lefttext &&
                        <div
                            className="popup_left_text_box"
                            style={!buttonCancel && !button ? { padding: "0" } : {}}
                        >
                            <p>{lefttext}</p>
                        </div>
                    }

                    <div className="licensing_subinfo_pop">
                        <div className="title_box">
                            <div 
                                className="popup_x_btn_box"
                            >
                                <p>{license.licenseGroup.subscription === null ? lang === 0 ? '발행 정보' : 'License Details' : lang === 0 ? '구독 정보' : 'Subscription information'}</p>
                                
                                <img src={require("../../assets/images/exit-icon.svg").default} 
                                    className="popup_x_btn" 
                                    onClick={() => {
                                        dispatch(close());
                                    }}
                                    style={{ cursor: isBrowser ? 'pointer' : 'auto' }}
                                />
                            </div>
                        </div>

                        <div className="licensing_subinfo_pop_content">
                            <p className="title">
                                {license.licenseGroup.licenseCategory === 0 && `UModeler X Pro${(isTrial ? ' Trial' : '')}`} 
                                {license.licenseGroup.licenseCategory === 1 === 'Art Pass' && 'UModeler X Art Pass'}
                                {license.licenseGroup.licenseCategory === 2 === 'All-In-One' && 'UModeler X All-In-One'}
                            </p>
                            
                            {!isTrial ? <div className="license_num_box">
                                <p>{lang === 0 ? '라이선스no:' : 'License No:'}</p>
                                <span>{license.licenseCode}</span>

                                {SubinfoTest === 0 &&
                                    <div className="license_num_view">
                                        <p>{lang === 0 ? '라이선스no:' : 'License No:'}</p>
                                        <span>20</span>
                                    </div>
                                }
                            </div> : <div style={{height: 20,}}/>}

                            <div className="info_box">
                                <div className="text_box">
                                    {license.licenseGroup.subscription !== null && <div className="text">
                                        <p>{lang === 0 ? '청구 옵션' : 'Billing Options'}</p>
                                        <span>{isTrial ? (
                                            lang === 0 ? '무료 체험' : 'Trial'
                                        ) : SubinfoPay === 0 ? '월간 결제' : '연 구독()'}</span>
                                    </div>}

                                    <div className="text">
                                        <p>{license.licenseGroup.subscription === null ? lang === 0 ? '발행일' : 'Start date' : lang === 0 ? `${isTrial ? '체험' : '구독'} 시작일` : 'Start date'}</p>
                                        <span>{moment(license.licenseGroup.createdAt).format('YYYY-MM-DD HH:mm')}</span>
                                    </div>

                                    {SubinfoTest != 0 &&
                                        <>
                                            {SubinfoType != 2 &&
                                                <>
                                                <div className="text">
                                                    <p>{license.licenseGroup.subscription === null || isTrial ? lang === 0 ? '사용기한' : 'Due date' : lang === 0 ? '다음 결제일' : 'Next Billing Date'}</p>
                                                    {/* {(SubinfoType == 0 || SubinfoType == 3) && */}
                                                        <span>{moment(license.licenseGroup.expiredAt).format('YYYY-MM-DD HH:mm')}</span>
                                                    {/* } */}

                                                    {!isTrial && SubinfoType == 1 &&
                                                        <span 
                                                            className="sub_cut_cancel"
                                                            onClick={() => {
                                                                dispatch(open({
                                                                    component: 
                                                                        <Popup01
                                                                            max_width={'400px'}
                                                                            SubCutCancel={true}
                                                                            infolicense={infolicense}
                                                                            button={lang === 0 ? '해지 취소' : 'Undo Cancellation'}
                                                                            buttonCancel={lang === 0 ? '닫기' : 'Close'}
                                                                            setFunc={async() => {
                                                                                dispatch(loadingStart());
                                                                                const result = await API.xsollaApis("user/subscribecancleback", {id: subscribelist[0]?.id});
                                                                                //console.log(result);
                                                                                if (result?.status === 200) {
                                                                                    navigate(routes.Licensing);
                                                                                    dispatch(open({
                                                                                        component: 
                                                                                            <Popup01
                                                                                                max_width={'300px'}
                                                                                                x_btn={false}
                                                                                                text1={lang === 0 ? '해지가 취소되었습니다.' : 'The cancellation has been canceled.'}
                                                                                                longButton={lang === 0 ? '확인' : 'OK'}
                                                                                            />
                                                                                    }));
                                                                                    payinfolists();
                                                                                    dispatch(loadingEnd());
                                                                                }
                                                                                if (result?.status === 400) {
                                                                                    dispatch(open({
                                                                                        component:
                                                                                            <Popup01
                                                                                                max_width={'300px'}
                                                                                                x_btn={false}
                                                                                                text1={result?.message}
                                                                                                longButton={lang === 0 ? '확인' : 'OK'}
                                                                                            />
                                                                                    }));
                                                                                }
                                                                            }}
                                                                        />
                                                                }));
                                                            }}
                                                        >
                                                            {lang === 0 ? '해지 취소' : 'Undo Cancellation'}
                                                        </span>
                                                    }
                                                </div>
                                                {SubinfoType == 0 &&
                                                <div className="text">
                                                    <p>{lang === 0 ? '다음 결제일' : 'Next Billing Date'}</p>
                                                    {/* {(SubinfoType == 0 || SubinfoType == 3) && */}
                                                        <span>{moment(license.licenseGroup.expiredAt).format('YYYY-MM-DD HH:mm')}</span>
                                                    {/* } */}
                                                </div>
                                                }                                     
                                                </>
                                            }
                                        </>
                                    }
                                    
                                </div>

                                <div className="date_box">
                                    {SubinfoType == 0 &&
                                        <>
                                            {/* <p className="date_ing">
                                                {payList?.filter(item => item?.ingstate*1 === 1 && item?.subscriptionId*1 === subscribelist[0]?.id*1)?.length}{subscribelist[0]?.planYorM*1 === 1 ? lang === 0 ? '개월' : 'Month' : lang === 0 ? '년' : 'Year'} 
                                                {lang === 0 ? '구독중' : 'Subscribed'}
                                            </p> */}
                                            <p 
                                                className="sub_cut"
                                                onClick={() => {
                                                    navigate(routes.CancelSub, {
                                                        state: {
                                                            infolicense: subscribelist[0]?.licenseCode,
                                                            infoTitle: subscribelist[0]?.plan,
                                                            subscribelist: subscribelist[0],
                                                            payList: payList,
                                                        }
                                                    });
                                                    dispatch(close());
                                                }}
                                            >
                                                {lang === 0 ? '구독해지' : 'Cancel Subscription'}
                                            </p>
                                        </>
                                    }

                                    {SubinfoType == 1 &&
                                        <>
                                            <p className="remain_date">{lang === 0 ? '잔여기간' : 'Remaining Period'}</p>
                                            <p className="remain_date_time">{diffdateCount}{lang === 0 ? '일' : 'day'}</p>
                                        </>
                                    }

                                    {SubinfoType == 2 &&
                                        <>
                                            <p className="sub_cut_suc">{lang === 0 ? '해지 완료' : 'Cancellation Completed'}</p>
                                        </>
                                    }
                                    {SubinfoType == 4 &&
                                        <>
                                            <p className="sub_cut_suc">{lang === 0 ? '만료' : 'Expiration'}</p>
                                        </>
                                    }
                                    {SubinfoType == 3 &&
                                        <>
                                            <div className="free_date">
                                                30일간 무료<br />
                                                (4일 남음)
                                            </div>
                                            <p 
                                                className="sub_cut"
                                                onClick={() => {
                                                    dispatch(open({
                                                        component: 
                                                            <Popup01
                                                                max_width={'400px'}
                                                                FreeCut={true}
                                                                button={'구독 해지'}
                                                                buttonCancel={'닫기'}
                                                                setFunc={() => {
                                                                    dispatch(loadingStart());
                                                                    setTimeout(() => {
                                                                        dispatch(open({
                                                                            component: 
                                                                                <Popup01
                                                                                    max_width={'300px'}
                                                                                    x_btn={false}
                                                                                    text1={'해지되었습니다.'}
                                                                                    longButton={lang === 0 ? '확인' : 'OK'}
                                                                                />
                                                                        }));
                                                                        dispatch(loadingEnd());
                                                                    }, 1000);
                                                                }}
                                                            />
                                                    }));
                                                }}
                                            >
                                                구독해지
                                            </p>
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    {(buttonCancel || button || longButton) &&
                        <div className="popup_btn_box">
                            {buttonCancel && (
                                <button
                                    className="button_cancel"
                                    onClick={() => {
                                        if (func === "setRightFunc") {
                                            setFunction();
                                        } else {
                                            if(cancelFunc) cancelFunc();
                                            dispatch(close());
                                        }
                                    }}
                                >
                                    {buttonCancel}
                                </button>
                            )}
                            {button && (
                                <button
                                    className="button_success"
                                    onClick={() => {
                                        
                                    }}
                                >
                                    {button}
                                </button>
                            )}
                            {longButton && (
                                <button
                                    className="button_success long"
                                    onClick={() => {
                                        if (func === "setRightFunc") {
                                            dispatch(close());
                                        } else {
                                            setFunction();
                                        }
                                    }}
                                >
                                    {longButton}
                                </button>
                            )}
                        </div>
                    }
                </div>
            </div>
        </>
    );
}
